import {
  IonCol,
  IonGrid,
  IonHeader,
  IonLoading,
  IonModal,
  IonRow,
} from "@ionic/react";
import React, { useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  createPatientStep2State,
  loggedInUserState,
  usernameInitialsState,
  selectedAssessmentState,
  networkConnectionStatus,
  currentAssessmentState,
  PatientState,
} from "../data/atoms";
import { useHistory } from "react-router";
import { ActionType } from "../models/Enums";
import { GetUserById } from "../services/AuthServices";
import { useForm } from "react-hook-form";
import { TestType } from "../models/Enums";
import { Link } from "react-router-dom";
import CancelLogoutModal from "./modals/cancel-logout-modal";
import SuccessModal from "./modals/success-modal";
import { PatientVM } from "../models/PatientVM";

interface Props {
  headerText: string;
  getUser?: Function;
  setModal?: Function;
  actionType?: ActionType;
  reset?: Function;
  exitModal?: Function;
  printPDF?: any;
  revertSelectedExercise?: any;
}

const TopLeftUserName: React.FC<Props> = ({
  headerText,
  getUser,
  reset,
  exitModal,
  printPDF,
  revertSelectedExercise,
}) => {
  const currentUrl = window.location.href.toString();
  const isFullVisit = currentUrl.includes("full-visit-summary");
  const isTermsOfServices = currentUrl.includes("termofservices");
  const isPrivacyPolicy = currentUrl.includes("privacypolicy");
  const isAbout = currentUrl.includes("about");
  const [currentAssessment] = useRecoilState(currentAssessmentState);
  let findAssessmentType =
    sessionStorage.getItem("selectedAssesment")! != null
      ? JSON.parse(sessionStorage.getItem("selectedAssesment")!)
      : currentAssessment.assessmentType;

  const [selectedAssessmentType, setSelectedAssessmentType] = useRecoilState(
    selectedAssessmentState
  );
  const [selectedId, setSelectedId] = useState(Number);

  let history = useHistory();
  const [showLoading, setShowLoading] = useState(false);
  const [printDisabled, setPrintDisabled] = useState(false);
  const [createPatientStep2, setCreatePatientStep2] = useRecoilState(
    createPatientStep2State
  );
  const [loggedInUser, setLoggedInUser] = useRecoilState(loggedInUserState);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus
  );
  const [cancelModal, setcancelModal] = useState(false);

  const {
    formState: { errors },
  } = useForm();
  const getUserCall = () => {
    debugger;
    if (getUser) {
      getUser();
    }
  };
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [patientDetailsRecoil, setPatientDetailsRecoil] =
    useRecoilState(PatientState);
  const [patientDetails, setPatientDetails] =
    useState<PatientVM>(patientDetailsRecoil);

  const redirectBackScreen = () => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    debugger;
    if (
      headerText === "User Profile" ||
      headerText === "Create New Patient" ||
      headerText === "Search"
    ) {
      history.replace("/home");
    } else if (headerText === "ExercisePlan") {
      // const storedValue = localStorage.getItem("exercisePlan");
      // if (storedValue === "true") {
      //   localStorage.removeItem("exercisePlan");
      //   history.push("/patient-page");
      // } else {
      //   localStorage.setItem("showRtmPopup", "true");
      //   window.dispatchEvent(new Event("showRtmPopup"));
      // }
      history.push("/patient-page");
    } else if (
      headerText === "Patient Page" ||
      headerText === "Assessment List"
    ) {
      history.push("/patient-page");
    } else if (
      headerText === "Assessment Selection" &&
      !window.location.href.includes("/gait-assessment-info")
    ) {
      setSelectedAssessmentType((prevState: any) => ({
        ...prevState,
        id: 0,
      }));
      setSelectedId(0);
      history.push("/select-an-assessment");
    } else if (
      headerText === "Assessment Selection" &&
      window.location.href.includes("/gait-assessment-info")
    ) {
      history.push("/select-assessment-type");
    } else if (
      headerText === "Patient Assessment Page" &&
      window.location.href.includes("/select-an-assessment")
    ) {
      history.push("/patient-page");
    } else if (
      headerText === "Patient Page" ||
      headerText === "Assessment List"
    ) {
      history.push("/patient-profile");
    } else if (headerText === "Instructions") {
      history.push("/select-assessment-type");
    } else if (headerText === "Setup Check") {
      history.push("/angle-adjustment", {
        assessmentType: findAssessmentType === TestType.gait ? "gait" : "5xsts",
      });
    } else if (headerText === "Review Exercises") {
      history.push("/full-visit-summary");
    } else if (headerText === "Add More Exercises") {
      revertSelectedExercise();
    } else if (headerText === "Duplicate Exercises") {
      console.log("patientDetails in topleftusername", patientDetails);
      sessionStorage.setItem("patientDetails", JSON.stringify(patientDetails));
      window.location.href = window.location.origin + "/full-visit-summary";
      // history.push("/full-visit-summary");
    } else if (isFullVisit) {
      history.replace("/patient-page", { props: true });
    } else if (isTermsOfServices || isPrivacyPolicy) {
      history.replace("/about");
    } else if (isTermsOfServices || isPrivacyPolicy) {
      history.replace("/about");
    } else if (isAbout) {
      history.replace("/home");
    } else if (
      headerText === "Assessment Type" &&
      window.location.href.includes("angle-adjustment")
    ) {
      history.push("/select-assessment-type");
    } else {
      history.goBack();
    }
  };

  const handleModal = () => {
    debugger;
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    if (headerText === "Edit Patient") {
      history.goBack();
    } else if (
      headerText == "Edit Profile" ||
      headerText == "Edit User Profile"
    ) {
      if (exitModal) exitModal();
    } else if (headerText === "Password Reset") {
      if (exitModal) exitModal();
    } else if (
      headerText === "Account Registration" &&
      window.location.href.includes("/email")
    ) {
      if (exitModal) exitModal();
    } else if (
      headerText === "Account Registration" &&
      window.location.href.includes("/code")
    ) {
      if (exitModal) exitModal();
    } else if (
      headerText === "Account Registration" &&
      window.location.href.includes("/signup-password")
    ) {
      if (reset) reset();

      history.push("/confirmation", {
        actionType: ActionType.ExitUserSetupFromSignupPassword,
      });
    } else if (
      headerText === "Account Registration" &&
      window.location.href.includes("/signup")
    ) {
      history.push("/confirmation", {
        actionType: ActionType.ExitUserSetupFromSignup,
      });
    } else if (headerText === "Full Visit Summary") {
      const storedValue = localStorage.getItem("rtmEnabledRefOnCompletion");
      if (storedValue === "true") {
        localStorage.setItem("rtmEnabledRefOnCompletion", "true");
        window.dispatchEvent(new Event("showRtmPopupOnCompletion"));
      } else {
        localStorage.removeItem("rtmEnabledRefOnCompletion");
        history.push("/patient-page");
      }
    } else if (window.location.href.includes("/select-assessment-type")) {
      setSelectedAssessmentType((prevState: any) => ({
        ...prevState,
        id: 0,
      }));
      setSelectedId(0);
      history.push("/select-an-assessment");
    } else if (window.location.href.includes("/gait-assessment-info")) {
      setSelectedAssessmentType((prevState: any) => ({
        ...prevState,
        id: 0,
      }));
      setSelectedId(0);
      history.push("/select-assessment-type");
    } else if (window.location.href.includes("/phone-height-requirement")) {
      history.push("/angle-adjustment");
    }
  };

  async function handleClickUser() {
    setIsMenuOpened(!isMenuOpened);
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setShowLoading(true);
    try {
      await GetUserById({
        localDateTime: new Date(),
        loggedInUserID: 0,
      })
        .then(function (response) {
          if (response!.data.responseCode === 1) {
            setCreatePatientStep2(false);
            setLoggedInUser(response!.data.user);
            history.replace("/user-profile");
          } else {
            console.log(errors);
          }
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error: any) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
    }
    setShowLoading(false);
  }

  const handleAboutClick = () => {
    setIsMenuOpened(!isMenuOpened);
    history.replace("/about");
  };

  const renderHeaderTitle = (
    isFullVisit: boolean,
    headerText: string,
    isMenuOpened: boolean
  ) => {
    const directHeaderTitles = [
      "Search",
      "Assessment Selection",
      "Assessment Type",
      "Angle Calibration",
    ];

    if (directHeaderTitles.includes(headerText)) return headerText;

    if (
      ["Patient Assessment Page", "Assessment List", "Patient Page"].includes(
        headerText
      ) ||
      isFullVisit
    ) {
      return "Patient Page";
    }

    return "";
  };

  const renderCenterTitle = (
    headerText: string,
    isFullVisit: boolean,
    isMenuOpened: boolean
  ) => {
    const centerTitles = [
      "Full Visit Summary",
      "Edit Patient",
      "Edit User Profile",
      "User Profile",
      "Review Exercises",
      "Duplicate Exercises",
      "Add More Exercises",
      "Account Registration",
      "Password Reset",
      "About",
      "Terms of Service",
      "Privacy Policy",
      "Create New Patient",
      "Send Exercise Plan",
    ];

    if (headerText === "Select a Patient" && !isMenuOpened) return headerText;
    else if (isMenuOpened && headerText === "Select a Patient") return "Menu";
    else if (
      (headerText === "Full Visit Summary" && !isFullVisit) ||
      centerTitles.includes(headerText)
    ) {
      return headerText;
    }

    return "";
  };

  let usernameInitials = useRecoilValue(usernameInitialsState);
  return (
    <>
      <IonLoading
        cssClass="my-custom-class"
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        message={"Please wait..."}
        duration={5000}
      />

      <IonModal
        className="overall-center-modal-main-wrap"
        backdropDismiss={false}
        isOpen={cancelModal}
        placeholder={undefined}
      >
        <CancelLogoutModal setShowModal1={setcancelModal}></CancelLogoutModal>
      </IonModal>

      <IonHeader placeholder={undefined} className="main-header-sec">
        <div
          className={
            isMenuOpened ? "header-menu-wrap show" : "header-menu-wrap"
          }
        >
          <ul className="dropdown-value">
            <li onClick={handleClickUser}>
              <Link to="/user-profile">User Profile</Link>
            </li>

            <li onClick={handleAboutClick}>
              <Link to="/about">About</Link>
            </li>

            <li
              onClick={() => {
                setcancelModal(true);
              }}
            >
              Logout
            </li>
          </ul>
        </div>

        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row align-items-center" placeholder={undefined}>
            <IonCol className="col-sec" size="3" placeholder={undefined}>
              <div className="header-main-sec-wrap">
                {headerText === "Select a Patient" && !isMenuOpened ? (
                  <div className="left-top-user-btn" id="main">
                    <div className="notification-msg-wrap">
                      <svg
                        onClick={() => setIsMenuOpened(!isMenuOpened)}
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                      >
                        <path
                          d="M0 4.55357C0 3.21027 1.08527 2.125 2.42857 2.125H31.5714C32.9147 2.125 34 3.21027 34 4.55357C34 5.89687 32.9147 6.98214 31.5714 6.98214H2.42857C1.08527 6.98214 0 5.89687 0 4.55357ZM0 16.6964C0 15.3531 1.08527 14.2679 2.42857 14.2679H31.5714C32.9147 14.2679 34 15.3531 34 16.6964C34 18.0397 32.9147 19.125 31.5714 19.125H2.42857C1.08527 19.125 0 18.0397 0 16.6964ZM34 28.8393C34 30.1826 32.9147 31.2679 31.5714 31.2679H2.42857C1.08527 31.2679 0 30.1826 0 28.8393C0 27.496 1.08527 26.4107 2.42857 26.4107H31.5714C32.9147 26.4107 34 27.496 34 28.8393Z"
                          fill="#802392"
                        />
                      </svg>
                    </div>
                  </div>
                ) : (
                  headerText === "Select a Patient" && (
                    <div className="header-left-arrow">
                      <svg
                        className="svg-icons cursor-pointer"
                        width="16"
                        height="26"
                        viewBox="0 0 16 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {
                          setIsMenuOpened(!isMenuOpened);
                        }}
                      >
                        <path
                          d="M14.8738 21.9379L5.75957 13.0063L14.8867 4.0621L14.8867 4.06211L14.8903 4.05847C15.706 3.24249 15.7059 1.92345 14.8738 1.10795C14.0466 0.297348 12.7153 0.297348 11.8881 1.10795L1.02777 11.7507C0.324078 12.4403 0.324078 13.5597 1.02777 14.2493L11.8881 24.892C12.7153 25.7027 14.0466 25.7027 14.8738 24.892C15.7066 24.0759 15.7066 22.754 14.8738 21.9379Z"
                          fill="#31344E"
                          stroke="black"
                        />
                      </svg>
                    </div>
                  )
                )}

                {
                  /* Back icon */
                  (headerText !== "Select a Patient" &&
                    headerText !== "Password Reset" &&
                    headerText !== "Account Registration" &&
                    headerText !== "Full Visit Summary" &&
                    headerText !== "Edit Profile" &&
                    headerText !== "Edit User Profile" &&
                    headerText !== "Edit Patient") ||
                  isFullVisit ? (
                    <div className="header-left-arrow">
                      <svg
                        className="svg-icons cursor-pointer"
                        width="16"
                        height="26"
                        viewBox="0 0 16 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {
                          redirectBackScreen();
                        }}
                      >
                        <path
                          d="M14.8738 21.9379L5.75957 13.0063L14.8867 4.0621L14.8867 4.06211L14.8903 4.05847C15.706 3.24249 15.7059 1.92345 14.8738 1.10795C14.0466 0.297348 12.7153 0.297348 11.8881 1.10795L1.02777 11.7507C0.324078 12.4403 0.324078 13.5597 1.02777 14.2493L11.8881 24.892C12.7153 25.7027 14.0466 25.7027 14.8738 24.892C15.7066 24.0759 15.7066 22.754 14.8738 21.9379Z"
                          fill="#31344E"
                          stroke="black"
                        />
                      </svg>
                      {headerText == "Patient Info" && (
                        <span>Patient Info</span>
                      )}
                    </div>
                  ) : null
                }
                <div className="header-tittle-sec-wrap">
                  <span
                    className="header-tittle-sec text-left"
                    style={
                      headerText === "Assessment Selection"
                        ? { paddingLeft: "245px" }
                        : headerText === "Assessment Type" ||
                          headerText === "Angle Calibration"
                        ? { paddingLeft: "265px" }
                        : headerText === "Patient Assessment Page"
                        ? { paddingLeft: "285px" }
                        : undefined
                    }
                  >
                    {renderHeaderTitle(isFullVisit, headerText, isMenuOpened)}
                  </span>
                </div>
              </div>
            </IonCol>
            <IonCol className="col-sec" size="6" placeholder={undefined}>
              <div className="header-tittle-sec-wrap">
                <span className="header-tittle-sec text-center">
                  {renderCenterTitle(headerText, isFullVisit, isMenuOpened)}
                </span>
              </div>
            </IonCol>
            <IonCol className="col-sec" size="3" placeholder={undefined}>
              <div className="right-cross-sec text-right">
                {/* *********** pdf download icon ********************* */}
                {(headerText == "Review Exercises" ||
                  headerText == "Duplicate Exercises") && (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => {
                      printPDF();
                    }}
                  >
                    <g clipPath="url(#clip0_4927_43415)">
                      <path
                        d="M10.7079 0.295518L10.6786 0.266229H10.6738C10.1444 -0.231652 9.31036 -0.221888 8.79295 0.295518L3.79271 5.29576C3.26535 5.82312 3.26535 6.67944 3.79271 7.2068C4.32007 7.73416 5.17639 7.73416 5.70375 7.2068L8.40037 4.51018V12.4996C8.40037 13.2463 9.00376 13.8497 9.75043 13.8497C10.4971 13.8497 11.1005 13.2463 11.1005 12.4996V4.51019L13.7971 7.2068C14.3245 7.73416 15.1808 7.73416 15.7081 7.2068C16.2355 6.67944 16.2355 5.82312 15.7081 5.29576L10.7079 0.295518ZM3.60012 13.7497C3.60012 13.003 2.99673 12.3996 2.25006 12.3996C1.50339 12.3996 0.9 13.003 0.9 13.7497V16.2498C0.9 18.3755 2.62454 20.1 4.75018 20.1H14.7507C16.8763 20.1 18.6009 18.3755 18.6009 16.2498V13.7497C18.6009 13.003 17.9975 12.3996 17.2508 12.3996C16.5041 12.3996 15.9007 13.003 15.9007 13.7497V16.2498C15.9007 16.886 15.3869 17.3999 14.7507 17.3999H4.75018C4.11397 17.3999 3.60012 16.886 3.60012 16.2498V13.7497Z"
                        fill="#002E3C"
                        stroke="#002E3C"
                        strokeWidth="0.2"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4927_43415">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
                {/* *********** pdf download icon end ********************* */}

                {(headerText === "Edit Profile" ||
                  headerText === "Password Reset" ||
                  headerText === "Account Registration" ||
                  headerText === "Full Visit Summary" ||
                  window.location.href.includes("/select-assessment-type") ||
                  window.location.href.includes("/gait-assessment-info") ||
                  window.location.href.includes("/phone-height-requirement") ||
                  headerText === "Edit Patient") && (
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => {
                      handleModal();
                    }}
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.43934 0.43934C1.02513 -0.146447 1.97487 -0.146447 2.56066 0.43934L13.5606 11.4392C14.1463 12.025 14.1463 12.9748 13.5606 13.5606C12.9748 14.1463 12.025 14.1463 11.4392 13.5606L0.43934 2.56066C-0.146447 1.97487 -0.146447 1.02513 0.43934 0.43934Z"
                      fill="#D1D1D1"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13.5606 0.43934C14.1464 1.02513 14.1464 1.97487 13.5606 2.56066L2.56066 13.5606C1.97487 14.1464 1.02513 14.1464 0.43934 13.5606C-0.146447 12.9748 -0.146447 12.0251 0.43934 11.4393L11.4393 0.43934C12.0251 -0.146447 12.9748 -0.146447 13.5606 0.43934Z"
                      fill="#D1D1D1"
                    />
                  </svg>
                )}
                {headerText == "Edit User Profile" && (
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => {
                      handleModal();
                    }}
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.43934 0.43934C1.02513 -0.146447 1.97487 -0.146447 2.56066 0.43934L13.5606 11.4392C14.1463 12.025 14.1463 12.9748 13.5606 13.5606C12.9748 14.1463 12.025 14.1463 11.4392 13.5606L0.43934 2.56066C-0.146447 1.97487 -0.146447 1.02513 0.43934 0.43934Z"
                      fill="#D1D1D1"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13.5606 0.43934C14.1464 1.02513 14.1464 1.97487 13.5606 2.56066L2.56066 13.5606C1.97487 14.1464 1.02513 14.1464 0.43934 13.5606C-0.146447 12.9748 -0.146447 12.0251 0.43934 11.4393L11.4393 0.43934C12.0251 -0.146447 12.9748 -0.146447 13.5606 0.43934Z"
                      fill="#D1D1D1"
                    />
                  </svg>
                )}

                {(headerText === "User Profile" ||
                  headerText === "Patient Page") && (
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => {
                      getUserCall();
                    }}
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M23.824 15.0739L9.77323 29.1247C9.48746 29.4105 9.09987 29.571 8.69573 29.571H2.04749C1.20591 29.571 0.523682 28.8888 0.523682 28.0472L0.523682 21.399C0.523682 20.9948 0.684225 20.6073 0.969995 20.3215L19.7395 1.55202C20.9836 0.307856 23.0008 0.307856 24.245 1.55202L28.5427 5.84975C29.7869 7.09391 29.7869 9.11109 28.5427 10.3552L23.8392 15.0588C23.8367 15.0613 23.8342 15.0638 23.8316 15.0664C23.8291 15.0689 23.8266 15.0714 23.824 15.0739ZM21.8945 3.70701C21.9484 3.65302 22.036 3.65302 22.09 3.70701L26.3877 8.00474C26.4417 8.05873 26.4417 8.14626 26.3877 8.20026L22.7541 11.8338L18.2609 7.3406L21.8945 3.70701ZM16.1059 9.49559L3.5713 22.0302V26.5234H8.06455L20.5991 13.9888L16.1059 9.49559Z"
                      fill="#802392"
                    />
                  </svg>
                )}
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonHeader>
      <div
        className={
          isMenuOpened ? "header-menu-backdrop show" : "header-menu-backdrop"
        }
      ></div>
    </>
  );
};
export default TopLeftUserName;
